module.exports = __webpack_public_path__ + "img/wc-erp-logo.5c577cb2.png";